module.exports = __webpack_public_path__ + "img/English-08.a4cc49b2.jpg";